import * as React from "react";
import { Grid } from "@mui/material";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import CclDataGridToolbar from "../../../components/common/cclDataGridToolbar/cclDataGridToolbar";
import { useGetAllTrainersQuery } from "../../../services/cclTokenedPayrollApi";
import AddTrainerDrawer from "./addTrainerDrawer";

interface TrainerTabPanelProps {}

const TrainerTabPanel: React.FC<TrainerTabPanelProps> = () => {

    const { data: trainers, isLoading: loading } = useGetAllTrainersQuery();

    const [addTrainerDrawerOpen, setAddTrainerDrawerOpen] = React.useState(false);

    const handleAddTrainer = () => {
        setAddTrainerDrawerOpen(true);
    };

    const handleCloseAddTrainerDrawer = () => {
        setAddTrainerDrawerOpen(false);
    };

    const handleToolbarButtonClick = (btnId: string) => {
        if (btnId === "add-trainer-button") {
            handleAddTrainer();
        }
    };

    const COLUMNS = [
        {
            field: "empId",
            headerName: "Employee ID",
            width: 200,
        },
        {
            field: "name",
            headerName: "Name",
            width: 200,
        },
        {
            field: "email",
            headerName: "Email",
            width: 250,
        },
        {
            field: "phone",
            headerName: "Phone",
            width: 150,
        },
        {
            field: "reportCampus",
            headerName: "Report Campus",
            width: 200,
        },
        {
            field: "empStartDate",
            headerName: "Employee Start Date",
            width: 150,
        },
        {
            field: "location",
            headerName: "Location",
            width: 150,
        },
    ];

    return (
        <React.Fragment>
            <Grid
                container
                spacing={0}
                alignItems="stretch"
                sx={{ justify: "space-between", flexGrow: 1 }}
            >
                <Grid item sx={{ display: "flex", flexDirection: "column", width: 1, height: 1 }}>
                    <DataGridPremium 
                        columns={COLUMNS}
                        components={{Toolbar: CclDataGridToolbar}}
                        getRowId={(row) => row.empId}
                        componentsProps={{
                            toolbar: {
                                showSaveState: false,
                                hideSettingsButtons: true,
                                savestate: null,
                                clearstate: null,
                                anySelected: false,
                                miscButtons: [
                                    {
                                        id: "add-trainer-button",
                                        caption: "Add Trainer",
                                        onClick: null,
                                        returnSelected: false,
                                        restricted: false,
                                    },
                                ],
                                btnClick: handleToolbarButtonClick,
                            },
                        }}
                        autoHeight 
                        rows={trainers || []}
                        loading={loading}

                    />
                    <AddTrainerDrawer
                        open={addTrainerDrawerOpen}
                        onClose={handleCloseAddTrainerDrawer}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default TrainerTabPanel;
